import { Typography } from '@mui/material'
import BusinessIcon from '@mui/icons-material/Business'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import SpeedIcon from '@mui/icons-material/Speed'
import SearchIcon from '@mui/icons-material/Search'
import { Card, Icon } from '@/components/common'

/**
 * Value card props
 */
export interface ValueCardProps {
  /** Icon component */
  icon: React.ElementType
  /** Card title */
  title: string
  /** Card description */
  description: string
}

/**
 * ValueCard Component
 * Displays a single value proposition with icon
 */
export const ValueCard = ({ icon, title, description }: ValueCardProps) => {
  return (
    <Card
      hover
      elevation={1}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        p: 3,
      }}
    >
      <Icon
        icon={icon}
        size="large"
        color="primary"
        sx={{
          fontSize: '3rem',
          mb: 2,
        }}
      />
      <Typography
        variant="h6"
        component="h3"
        sx={{
          fontWeight: 600,
          mb: 1.5,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          lineHeight: 1.6,
        }}
      >
        {description}
      </Typography>
    </Card>
  )
}

/**
 * Icon mapping for value cards
 */
export const valueIcons = {
  'Built for Small Businesses': BusinessIcon,
  'Designed to Generate Leads': TrendingUpIcon,
  'Mobile-First & Fast': SpeedIcon,
  'Local SEO Ready': SearchIcon,
}
